import {
	OriginConnectionPosition,
	OverlayConnectionPosition,
} from '../../viewport/calculate-overlay';
import { ConnectedPositionStrategy } from './connected-position-strategy';
import { GlobalPositionStrategy } from './global-position-strategy';

export class OverlayPositionBuilder {
	static global() {
		return new GlobalPositionStrategy();
	}

	static connectedTo(
		elementRef: HTMLElement
	) {
		return new ConnectedPositionStrategy(elementRef);
	}
}
